<template>
  <div v-if="detailsData">
    <div @mouseup='lookUp' @mousedown='lookDown' class="center">
      <h1 v-if="detailsData.title" class="title">{{ detailsData.title }}</h1>
      <ul class="content">
        <li class="msg">
          <span v-if="detailsData.perName">{{ detailsData.perName }} &nbsp;&nbsp;</span> 
          <span v-if="detailsData.updTime">{{ $global.transferDay(detailsData.updTime) }}</span>
        </li>
      </ul>
      <div v-if="detailsData.content" class="text" v-html="detailsData.content"></div>
    </div>
      <LookUpTheWord @CloseToRetrieve="CloseToRetrieve" :coord='coord' v-if="isCheck" />
  </div>
</template>

<script>
import LookUpTheWord from '@/components/pager/lookUpTheWord.vue'
export default {
  name: "center",
  props: ["detailsData"],
  components:{
    LookUpTheWord
  },
  data(){
    return{
      isCheck: false,
      coord:{
        x:0,
        y:0,
        text:''
      }
    }
  },
  watch:{
    //监视词条
    'coord.text':{ //如果有内容则显示组件
      immediate:true, //立即执行
      handler(){
        if(this.coord.text && !/^\s+$/.test(this.coord.text)){
        this.isCheck=true
        }
      }
    }
  },
  methods:{
    // 鼠标按下
    lookDown(){
      this.isCheck=false //关闭检索组件
    },
    // 鼠标抬起
    lookUp(event){
      console.log(event)
      this.coord.x= event.clientX //水平坐标
      this.coord.y = event.clientY //垂直坐标
      this.coord.text=window.getSelection().toString() //选中的文本
    },
    CloseToRetrieve(){ //关闭按钮
      this.isCheck=false //关闭组件
    },
  }
};
</script>

<style lang="scss" scoped>
.center {
  padding-top: 43px;
  width: 905px;
  //height: 657px;
  background: #ffffff;
  padding-bottom: 50px;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  border: 1px solid #A3CBE7;
  border-radius: 10px;

  .title {
    width: 831px;
    font-size: 30px;
    //font-family: Microsoft YaHei;
    font-weight: bold;
    color: #263d78;
    margin: 0 auto 20px;
    line-height: 48px;
  }

  .content {
    width: 830px;
    margin: 0px auto 0;

    .msg {
      margin-bottom: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 30px;
    }
  }

  .text {
    //text-indent: 20px;
    width: 830px;
    margin: 10px auto;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    &::v-deep video,
    &::v-deep img{
      width: 100% !important;
    }
  }
  .list {
    width: 830px;
    margin: 0 auto;

    text-indent: 20px;
    //margin: 10px auto;
  }
}
</style>
